export default "/imgs/investigation-04.png"